<div class="modal-container">
  <h2>{{ 'sdg.grid.tablesettings' | localize }}</h2>

  <div class="settings-section">
    <h3>{{ 'sdg.grid.filters' | localize }}</h3>
    
    <div class="drag-container">
      
      <div class="list-container">
        <h4>{{'sdg.grid.hidden' | localize }}</h4>
        <div
          cdkDropList
          #hiddenList="cdkDropList"
          [cdkDropListData]="hiddenFilters()"
          [cdkDropListConnectedTo]="[visibleList]"
          class="drop-list"
          (cdkDropListDropped)="drop($event)">
          
          @for (filter of this.hiddenFilters(); track filter.column){
            <div class="drag-item" cdkDrag>
              {{ filter.label| localize }}
              <span class="drag-handle">☰</span>
            </div>
          }
        </div>
      </div>

      <div class="list-container">
        <h4>{{ 'sdg.grid.active' | localize }}</h4>
        <div
          cdkDropList
          #visibleList="cdkDropList"
          [cdkDropListData]="visibleFilters()"
          [cdkDropListConnectedTo]="[hiddenList]"
          class="drop-list"
          (cdkDropListDropped)="drop($event)">

          @for (filter of this.visibleFilters(); track filter.column){
            <div class="drag-item" cdkDrag>
              {{ filter.label | localize }}
              <span class="drag-handle">☰</span>
            </div>
          }
        </div>
      </div>
      
    </div>
  </div>

  <div class="settings-section">
    <h3>{{ 'sdg.grid.columns' | localize }}</h3>
    
    <div class="drag-container">
      
      <div class="list-container">
        <h4>{{ 'sdg.grid.hidden' | localize }}</h4>
        <div
          cdkDropList
          #hiddenCols="cdkDropList"
          [cdkDropListData]="hiddenColumns()"
          [cdkDropListConnectedTo]="[visibleCols]"
          class="drop-list"
          (cdkDropListDropped)="drop($event)">
          
          @for (col of this.hiddenColumns(); track col.name){
            <div class="drag-item" cdkDrag>
              {{ col.displayname | localize }}
              <span class="drag-handle">☰</span>
            </div>
          }
        </div>
      </div>

      <div class="list-container">
        <h4>{{ 'sdg.grid.active' | localize }}</h4>
        <div
          cdkDropList
          #visibleCols="cdkDropList"
          [cdkDropListData]="visibleColumns()"
          [cdkDropListConnectedTo]="[hiddenCols]"
          class="drop-list"
          (cdkDropListDropped)="drop($event)">

          @for (col of this.visibleColumns(); track col.name){
            <div class="drag-item" cdkDrag>
              {{ col.displayname | localize }}
              <span class="drag-handle">☰</span>
            </div>
          }
        </div>
      </div>
      
    </div>
  </div>

  <div class="modal-pagesize">
    <label class="modal-pagesize__label">{{ 'sdg.grid.pocet_zaznamu_na_stranku' | localize }}</label>
    <input type="number" min="1" class="modal-pagesize__input" [value]="pageSize()" (input)="onPageSizeInput($any($event.target).value)" />
  </div>

  <div class="modal-footer">
    <button (click)="resetToDefaults()" class="gov-button gov-button--primary-outlined gov-button--small">{{ 'sdg.grid.button.reset' | localize }}</button>
    <button (click)="storno()" class="gov-button gov-button--primary-outlined gov-button--small">{{ 'sdg.grid.button.cancel' | localize }}</button>
    <button (click)="saveAndClose()" class="gov-button gov-button--primary gov-button--small">{{ 'sdg.grid.button.save' | localize }}</button>
  </div>
</div>